import axios, { AxiosResponse, CancelTokenSource } from "axios";
import { ReprintParams } from "../types/reprintParams";
import { PrintHistoryRequest } from "../types/printHistoryRequest";
import { aplClient } from "./apiClient";

let reprintPalletsCancelToken: CancelTokenSource | null = null;

const cancelReprinting = () => reprintPalletsCancelToken?.cancel();

const reprintPallets = (printParams: ReprintParams): Promise<AxiosResponse<PrintHistoryRequest[], any>> => {
    reprintPalletsCancelToken = axios.CancelToken.source();

    return aplClient().post(`reprint`, printParams, {
        cancelToken: reprintPalletsCancelToken.token
    });
};

export { reprintPallets, cancelReprinting };
